export default __webpack_public_path__ + "static/media/TheMixC5-7_Bold.3208fc49.woff2";